<template>
    <v-icon
        :color="color"
        :small="small"
        :right="right"
        :left="left"
        :x-small="xSmall"
        :large="large"
        :size="size"
        :class="classList"
        @click="$emit('click')"
    >
        {{ `$${icon}` }}
    </v-icon>
</template>

<script>
export default {
    name: "Icon",
    props: {
        color: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            required: true
        },
        small: {
            type: Boolean,
            default: false
        },
        xSmall: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        left: {
            type: Boolean,
            default: false
        },
        size: {
            type: [Number, String],
            default: null
        },
        classList: {
            type: String,
            default: null
        }
    }
}
</script>
